<template>
  <div class="tw-flex-row tw-flex tw-py-[30px] tw-items-center">
    <span class="divider" />
    <span class="tw-font-montserrat-regular tw-text-sm tw-px-[8px] tw-text-cool-grey-500">{{
      $t('or')
    }}</span>
    <span class="divider" />
  </div>
</template>
<style scoped>
.divider {
  @apply tw-flex-grow tw-h-[1px] tw-bg-secondary-light tw-mt-[2px];
}
</style>
